import store, {
  chainIdChange,
  routerChange,
  rpcChange,
  tokenChange,
  feeV3Change,
  privatekeyArrayChange,
  botConfigChange,
  isErrorNetworkChange,
  slippageChange,
  isShowGasChange,
  isAdvancedChange,
  gasChange,
  spenTokenChange,
  gasLimitChange,
  batchConfigChange
} from '@/store';
import { storageUtil } from '@/hooks/useStorage';

/**
 * 初始化用户数据
 */
export function initializeUserData(_botConfig,_slippage) {
  const dispatch = store.dispatch; // 如果你在组件外没有 useDispatch，可以直接用 store.dispatch

  const stored = storageUtil.get('user');
  if (!stored?.globalTargetData) return;

  const globalTargetData = stored.globalTargetData;
  const modes = stored?.modes;
  if (!modes) return;

  // 更新 Redux 状态
  dispatch(chainIdChange(globalTargetData.chainId));
  dispatch(routerChange(globalTargetData.router));
  dispatch(rpcChange(globalTargetData.rpc));
  dispatch(tokenChange(globalTargetData.token));
  dispatch(feeV3Change(globalTargetData.feeV3));
  dispatch(spenTokenChange(globalTargetData.spenToken));
  dispatch(privatekeyArrayChange(globalTargetData.privatekeyArray));
  dispatch(isAdvancedChange(globalTargetData.isAdvanced))
  // 初始化 botConfig
  const res = globalTargetData.mainConfig
  // console.log(res,'res');
  const newBotConfig = {
    ..._botConfig,
    ...(modes[res?.mode]?.[res.isBuyAmount + 'buy'] || {}),
    ...(modes[res?.mode]?.[res.isSellAmount + 'sell'] || {}),
    ...(modes[res?.mode]?.timeRange || {}),
    buyPro: modes[res?.mode]?.buyPro || '',
    price: modes[res?.mode]?.price || '',
    minPrice: modes[res?.mode]?.minPrice || '',
    maxPrice: modes[res?.mode]?.maxPrice || '',
  };
  // console.log(newBotConfig,'newBotConfig');
  dispatch(botConfigChange(newBotConfig));
  // console.log(modes[res?.mode]?.batchConfig, 'modes[res?.mode]?.batchConfig');
  dispatch(batchConfigChange(modes[res?.mode]?.batchConfig ?? { isBatch: "", number: "" }));

  dispatch(isErrorNetworkChange(globalTargetData.isError));
  dispatch(slippageChange(modes[res?.mode]?.slippage || _slippage));
  dispatch(isShowGasChange(modes[res?.mode]?.isShowGas || false));
  // dispatch(isAdvancedChange(modes[res?.mode]?.isAdvanced || false));
  dispatch(gasChange(modes[res?.mode]?.gas || ''));
  dispatch(gasLimitChange(modes[res?.mode]?.gasLimit || ''));
}
